//import {map, set,iterator} from 'core-js/es6';
import { UtilService, populateProductSpace,populatePartProductOverviewSpace,
     getURLParameter } from './UtilService';
import { ViewPortModus, ViewportScrollInformations, SpaceProperty, Language, Product, ProductVersion, ProductSection} from './ProductModels';
import { Log, ILogger } from './Logger';
//import { Config } from './ViewportConfig';

var TEMPLATE_PRODUCT_VIEWPORT = process.env.VUE_APP_TEMPLATE_PRODUCT_VIEWPORT;
var TEMPLATE_INDEX_VIEWPORT = process.env.VUE_APP_TEMPLATE_INDEX_VIEWPORT;

var SERVER_BASE_ADDRESS = process.env.VUE_APP_SERVER_BASE_ADRESS;

declare  var window:any;

 export abstract class Viewport {
    public static readonly REPLACEABLE_TEMPLATE_ID = "replaceable-template-block";
    public viewportModus: ViewPortModus;
    public viewportLanguage: Language;
    public utilserv: UtilService;
    protected readonly templateName: string;
    protected readonly spaceName: string;
    public readonly spaceKey: string;
    public readonly viewportScrollInformations:ViewportScrollInformations;
    public viewportEvironment:string='web';  //possible values web/softbooks

    // PRODUCT VIEWPORT STUFF
    constructor(lang: Language, vp_modus: ViewPortModus, VSI:ViewportScrollInformations, templateName?: string) {        
        this.viewportLanguage = lang;
        this.viewportModus = vp_modus;
        this.templateName = templateName;
        this.viewportScrollInformations = VSI;
        this.spaceName = VSI.spaceName;
        this.spaceKey = VSI.spaceKey;
        this.utilserv = new UtilService(lang,VSI);
    }

    public abstract bootstrapViewport(): void;

    public abstract handleLanguageChange(lang: Language): void;
}

export class IndexSearchViewport extends Viewport {

    constructor(language: Language, VSI:ViewportScrollInformations) {
        super(language, ViewPortModus.PRODUCT_SECTION, VSI);
    }

    public bootstrapViewport(): void {
        this.utilserv.loadDatas(Language[this.viewportLanguage]);
    } 

    public handleLanguageChange(lang: Language): void {
        let currentUrl = window.location.href;
        let newUrl = this.viewportScrollInformations.contextPath?SERVER_BASE_ADDRESS +'/'+this.viewportScrollInformations.contextPath:SERVER_BASE_ADDRESS;
        // newUrl+=window.location.port?':'+window.location.port:''; 
        let langPath = lang === Language.DE? process.env.VUE_APP_INDEX_PAGE_NAME_DE : process.env.VUE_APP_INDEX_PAGE_NAME_EN;
        newUrl +='/'+langPath;
        //console.log("PRINTING NEW  URL"+process.env.VUE_APP_INDEX_PAGE_NAME_DE, newUrl);
        
        window.location.href = newUrl;
    }
}


export class EmptyViewport extends Viewport {

    constructor(language: Language, VSI:ViewportScrollInformations) {
        super(language, ViewPortModus.NO_VIEWPORT, VSI);
    }

    public bootstrapViewport(): void {
      //  this.utilserv.loadDatas(Language[this.viewportLanguage]);
    } 

    public handleLanguageChange(lang: Language): void {
  /*      let currentUrl = window.location.href;
        let newUrl = SERVER_BASE_ADDRESS +'/'+this.viewportScrollInformations.contextPath;
        // newUrl+=window.location.port?':'+window.location.port:''; 
        let langPath = lang === Language.DE? process.env.VUE_APP_INDEX_PAGE_NAME_DE : process.env.VUE_APP_INDEX_PAGE_NAME_EN;
        newUrl +='/'+langPath;
        console.log("PRINTING NEW  URL"+process.env.VUE_APP_INDEX_PAGE_NAME_DE, newUrl);
        
        window.location.href = newUrl;*/
    }
}





export class PartProductOverviewport extends Viewport {
    public prodNameParam: string;
    public product:Product=null;
    public currentVersion:ProductVersion=null;
    public allProductVersions:ProductVersion[]= [];
    public prodVersionsWithoutCurrentVersion:ProductVersion[]=[];
    public prodVersionsWithoutCurrentVersionString:string[]=[];
    public productGroup:ProductSection= null;
    public allPartProducts:Product[]= [];
    public allPartProductsString:Set<string>= new Set<string>();
    public allProductVersionsString:Set<string>= new Set<string>();

    public allProductVersionSpaceKey:string[] = [];
    public prodVersions_to_partProdVersions: Map<string, Array<string>> = new Map<string, Array<string>>();
    public currentVersionString:string=null;

    constructor(language: Language,  VSI:ViewportScrollInformations,prodNameParam:string) {
       // super(language, ViewPortModus.PRODUCT_SECTION,VSI, TEMPLATE_PRODUCT_VIEWPORT);
        super(language, ViewPortModus.PRODUCT_SECTION,VSI, '');
        this.prodNameParam = prodNameParam;
    }

    public bootstrapViewport(): void {
        populatePartProductOverviewSpace(this.spaceKey, this.prodNameParam, this.viewportLanguage, this);
        //console.dir('POPULATE PART-PRODUCT SPACE');

      /*  if (window.SCROLL && window.SCROLL.initPageTree) {
            window.SCROLL.initPageTree();
        }
        */
    }

    public setPartViewportDatas(csvData:any[]):PartProductOverviewport{
        for(let item of csvData){
            if(item != null && item !==undefined && item['Produktgruppe_de'] ){
                this.productGroup = item['Produktgruppe_de'];
               item['Produkt_Version'].split(',').forEach(element => {
                    this.allProductVersionsString.add(element.trim());
                });
                this.allPartProductsString.add(item['Teilprodukt_de']);
            }
        }
        //console.log('GIB all prods raus:'+this.allProductVersionsString.size, this.allProductVersionsString);
        
        if(this.allProductVersionsString.size>0){
            //console.log('Hier waren wir');

            this.currentVersionString = this.prodNameParam+" "+Array.from(this.allProductVersionsString)[0];
        }
        return this;
    }

    public setVersionsDatas():PartProductOverviewport{
        for(let item of Array.from(this.allProductVersionsString)){
            let res=null;
            /*  encodeSpaceVersionKey(
                this.prodNameParam+item,
                this.viewportLanguage
            )
            */
            this.allProductVersionSpaceKey.push(res);
            if(this.currentVersionString!==item)
            {
                this.prodVersionsWithoutCurrentVersionString.push(item);
            }
             
            this.prodVersions_to_partProdVersions.set(res,[]);
            for(let partProdItem of Array.from(this.allPartProductsString)){
                this.prodVersions_to_partProdVersions.get(res).
                push(
                    /*encodeSpaceVersionKey(
                    partProdItem+item,
                    this.viewportLanguage)*/
                    ''
                )
            }
        }  

        //console.dir(this);
        return this;
    }

    public handleLanguageChange(lang: Language): void {

       /* let viewportPath = encodeSpaceVersionKey(this.spaceName, lang);
        let newUrl = window.location.origin;
     
        newUrl+='/';
        newUrl+=viewportPath;
        console.log('neue-url:',newUrl);
        window.location.href = newUrl;
        */
    }
}

export class ProductViewport extends Viewport {
    public product:Product=null;
    public currentVersion:ProductVersion=null;
    public allProductVersions:ProductVersion[]= [];
    public prodVersionsWithoutCurrentVersion:ProductVersion[]=[];
    public spaceProperty:SpaceProperty= null;
    public latestVersion:ProductVersion = null;
   
    constructor(spaceProperty:SpaceProperty, VSI:ViewportScrollInformations) {
        super(spaceProperty.lang, ViewPortModus.PRODUCT_SECTION,VSI, VSI.themeUrl+TEMPLATE_PRODUCT_VIEWPORT)
       // super(spaceProperty.lang, ViewPortModus.PRODUCT_SECTION,VSI, '')
        this.spaceProperty = spaceProperty;
    }

   public bootstrapViewport(): void {
        this.utilserv.loadProductVersionsDatas(this).then(result =>{
            populateProductSpace( this);
        })        

        //console.dir(this);

        if (window.SCROLL && window.SCROLL.initPageTree) {
            window.SCROLL.initPageTree();
        }
    }

    public handleLanguageChange(lang: Language): void {

        let viewportPath = getUrlOtherLanguageUrl(this.currentVersion.spaceUrl, this.viewportLanguage, lang);
        //let viewportPath = this.currentVersion.spaceUrl;
        /*let newUrl = window.location.origin;
     
        newUrl+=Config.CONTEXT_PATH;
        newUrl+='/';
        newUrl+=viewportPath;*/
        //console.log('neue-url:',viewportPath);
        window.location.href = viewportPath;
    }
}

export class IndexViewport extends Viewport {

    constructor(language: Language, VSI:ViewportScrollInformations) {
        super(language, ViewPortModus.PRODUCT_SECTION, VSI);
    }

    public bootstrapViewport(): void {
        this.utilserv.loadDatas(Language[this.viewportLanguage]);
    } 

    public handleLanguageChange(lang: Language): void {
        let currentUrl = window.location.href;
        let newUrl = this.viewportScrollInformations.contextPath?SERVER_BASE_ADDRESS +'/'+this.viewportScrollInformations.contextPath:SERVER_BASE_ADDRESS;        // newUrl+=window.location.port?':'+window.location.port:''; 
        let langPath = lang === Language.DE? process.env.VUE_APP_INDEX_PAGE_NAME_DE : process.env.VUE_APP_INDEX_PAGE_NAME_EN;
        newUrl +='/'+langPath;
        //console.log("PRINTING NEW  URL"+process.env.VUE_APP_INDEX_PAGE_NAME_DE, newUrl);
        
        window.location.href = newUrl;
    }
}

export function tableStyling() {
    $('table').addClass('table table-striped table-bordered table-hover');

    $("#confluence-content table td  a:not([href$='.pdf'])").html('<i class="fa fa-2x fa fa-html5 btn-outline-danger" aria-hidden="true"></i>')
    $("#confluence-content table td  a[href$='.pdf']:not(:has(img))").html('<i class="fa fa-2x fa-file-pdf-o btn-outline-danger" aria-hidden="true"></i>')

    // $("#confluence-content table td  a([href$='.pdf'][:not(:has(> img))])").html('<i class="fa fa-2x fa-file-pdf-o btn-outline-danger" aria-hidden="true"></i>')
}

export function getSpaceContentProperties(spaceKey: string, VSI:ViewportScrollInformations) {

    //console.log('CALLING CONTENT PROPERTY: ', `${SERVER_BASE_ADDRESS}${VSI.contextPath}/rest/api/space/${spaceKey}/property/property`,);
    
    return $.ajax({
      //  url: `${SERVER_BASE_ADDRESS}${Config.CONTEXT_PATH}/rest/api/space/${spaceKey}/property/property`,
        url: `${SERVER_BASE_ADDRESS}${VSI.contextPath}/rest/api/space/${spaceKey}/property/property`,
        method: 'GET',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        headers: {
            //  "Authorization": "Basic " + btoa(Config.+":"+password)
        } 
    });
}

export function getUrlOtherLanguageUrl(currentUrl:string, currentLang:Language, targetLang:Language):string{
let targetUrl = currentUrl;

//console.log('Current Language: '+Language[currentLang]+" target Language: "+Language[targetLang]);

let targetLangString = Language[targetLang].toLowerCase();

targetUrl = targetUrl.slice(0, -2) + targetLangString;
//console.log("Target Url: ",targetUrl);

return targetUrl;

}


